import React from 'react';
import './ContentItem.css';
import LoadingButton from '@mui/lab/LoadingButton';

const ContentItem = ({ item, onZoom, onPostToInstagram, postingToInstagramStories, onOpenInNewTab, backgroundColor }) => {
    const handlePostToInstagram = () => {
        onPostToInstagram();
    };

    return (
        <div className='grid__item' style={{ backgroundColor }}>
            {item.postImg && (
                <img
                    src={item.postImg}
                    alt={item.animal}
                    className='media'
                    style={{
                        aspectRatio: `${item.imageWidth} / ${item.imageHeight}`
                    }}
                    onClick={onZoom}
                />
            )}
            {item.postVideo && (
                <video
                    controls
                    onPlay={(e) => {
                        document.querySelectorAll('video').forEach(video => {
                            if (video !== e.target) {
                                video.pause();
                            }
                        });
                    }}
                    className='media'
                    style={{
                        aspectRatio: `${item.imageWidth} / ${item.imageHeight}`
                    }}
                >
                    <source src={item.postVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}

            <div className='meta'>
                <div>{item.likesCount} Likes</div>
                <div>{item.commentsCount} Comments</div>
                <div>{item.timeAgo}</div>
            </div>

            {item.animal && (
                <div className='animal-name'>
                    {item.animal}
                </div>
            )}

            <button
                className='open-new-tab-card-button'
                onClick={onOpenInNewTab}
            >
                Open in New Tab
            </button>

            {item.postVideo && (
                <LoadingButton
                    onClick={handlePostToInstagram}
                    loading={postingToInstagramStories === item.id}
                    variant="contained"
                    className='post-instagram-button'
                >
                    Post to Instagram Stories
                </LoadingButton>
            )}

        </div>
    );
};

export default ContentItem;
